




























































































































import JSEncrypt from "jsencrypt";
export default {
  name: "doctor-template-pc",
  data() {
    return {
      openEye: false,
      checked: false,
      clock: false,
      time: 60,
      formData: {
        phone: "",
        checkNum: "",
        password: "",
      },
      formTest: {
        phone: false,
        checkNum: false,
        password: false,
      },
      errorTip: "",
      errorPosition: "",
    };
  },
  props: ["config"],
  computed: {
    next: function() {
      const flag =
        (this as any).checked &&
        !(this as any).errorTip &&
        Object.keys((this as any).formData).every(
          (key) => (this as any).formData[key]
        ) &&
        Object.keys((this as any).formTest).every(
          (key) => !(this as any).formTest[key]
        );
      return flag;
    },
  },
  watch: {
    config: {
      handler(newCul: any) {
        const instance = this as any;
        instance.checked = newCul.protocolStatus;
      },
      immediate: true,
    },
    errorTip: {
      handler(newCul: any, oldCul: any) {
        const instance = this as any;
        if (!newCul && newCul !== oldCul) {
          const keyProp = Object.keys(instance.formTest).find(
            (key) => instance.formTest[key]
          );
          instance.test(keyProp);
        }
      },
    },
  },
  methods: {
    limit(key: string) {
      if (key === "phone" && (this as any).formData[key].length > 11) {
        (this as any).formData[key] = (this as any).formData[key].slice(0, 11);
      }
    },
    clear(propName: string) {
      (this as any).formData[propName] = "";
    },
    test(key: string) {
      const instance = this as any;
      if (key === "password") {
        const passwordReg = /^[0-9A-Za-z]{6,16}$/;
        if (!instance.formData[key]) {
          instance.errorTip = "请输入密码";
          instance.errorPosition = "password";
          instance.formTest[key] = true;
        } else if (!passwordReg.test(instance.formData[key])) {
          instance.errorTip = "请输入6-16位字母或数字的密码";
          instance.errorPosition = "password";
          instance.formTest[key] = true;
        } else {
          instance.errorTip = "";
          instance.errorPosition = "";
          instance.formTest[key] = false;
        }
      }
      if (key === "phone") {
        const phoneReg = /^[1][0-9]{10}$/;
        if (!instance.formData[key]) {
          instance.errorTip = "请输入手机号";
          instance.errorPosition = "phone";
          instance.formTest[key] = true;
        } else if (!phoneReg.test(instance.formData[key])) {
          instance.errorTip = "请输入正确的手机号码";
          instance.errorPosition = "phone";
          instance.formTest[key] = true;
        } else {
          instance.errorTip = "";
          instance.errorPosition = "";
          instance.formTest[key] = false;
        }
      }
    },
    goUrl(url: string) {
      window.location.href = url;
    },
    sendSms() {
      const phoneReg = /^[1][0-9]{10}$/;
      const instance = this as any;
      if (
        !(this as any).formData.phone ||
        !phoneReg.test(instance.formData.phone)
      ) {
        return;
      }
      (this as any).clock = true;
      (this as any).time = 60;
      const inter = setInterval(() => {
        (this as any).time--;
        if ((this as any).time <= 0) {
          clearInterval(inter);
          (this as any).clock = false;
        }
      }, 1000);
      const config = (this as any).config;
      const params = {
        businessType: config.businessType,
        phone: (this as any).formData.phone,
        smsType: config.smsType,
        userType: config.userType,
      };
      (this as any).$emit("send-sms", params);
    },
    encryptDeal(msg: string) {
      const publicKey =
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKbpotLkdWJlxvWuydKwQkryMb3m2mZrj8tizRUbwBW9Bnyu0syIXz+IkxP6Z76b4cEO2NyEq5yPcJdaBKynSVcCAwEAAQ==";

      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKey);
      return encrypt.encrypt(msg);
    },
    nextFun() {
      if (!(this as any).next) return;
      const instance = this as any;
      const config = (this as any).config;
      const params = {
        account: (this as any).formData.phone,
        checkNum: (this as any).formData.checkNum,
        userType: config.userType,
        password: instance.encryptDeal((this as any).formData.password),
        source: "pc",
      };
      (this as any).$emit("register-handle", params);
    },
  },
};
